import imgPeople_ from "./images/people.jpg";
import imgEnd_ from "./images/end.png";
import imgWall_ from "./images/wall.png";
import win_ from "./images/Win.png";
import Right001_ from "./images/Right001.png";
import Right002_ from "./images/Right002.png";
import Right003_ from "./images/Right003.png";
import Right004_ from "./images/Right004.png";
import Left001_ from "./images/Left001.png";
import Left002_ from "./images/Left002.png";
import Left003_ from "./images/Left003.png";
import Left004_ from "./images/Left004.png";

export const Right001 = new Image();
Right001.src = Right001_;
export const Right002 = new Image();
Right002.src = Right002_;
export const Right003 = new Image();
Right003.src = Right003_;
export const Right004 = new Image();
Right004.src = Right004_;


export const Left001 = new Image();
Left001.src = Left001_;
export const Left002 = new Image();
Left002.src = Left002_;
export const Left003 = new Image();
Left003.src = Left003_;
export const Left004 = new Image();
Left004.src = Left004_;

export const imgPeople = new Image();
imgPeople.src = imgPeople_;
export const imgEnd = new Image();
imgEnd.src = imgEnd_;
export const imgWall = new Image();
imgWall.src = imgWall_;
export const imgWin = new Image();
imgWin.src = win_;
